__turbopack_context__.v({
  "attentionNiceAcceptButton": "UrLJdG_attentionNiceAcceptButton",
  "charNice": "UrLJdG_charNice",
  "helpNiceDescription": "UrLJdG_helpNiceDescription",
  "helpNiceWord": "UrLJdG_helpNiceWord",
  "questionIcon": "UrLJdG_questionIcon",
  "switchNice": "UrLJdG_switchNice",
  "switchNiceContainer": "UrLJdG_switchNiceContainer",
});
